import { render } from "./ManageAuthTokens.vue?vue&type=template&id=89e12fe6"
import script from "./ManageAuthTokens.vue?vue&type=script&lang=js"
export * from "./ManageAuthTokens.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__